import React, {Component} from 'react'
import {ListGroup, ListGroupItem, Card, CardBody, CardHeader, CardTitle, CardText} from 'reactstrap'
import {Query} from 'react-apollo'
import moment from 'moment'

import QUERY from '../../../queries/server/user_undertime'

export default ({user_id}) => {

    return (
        <Query fetchPolicy="network-only" query={QUERY} variables={{user_id}}>
            {({loading, error, data}) => {
                if (loading) return <h3>Loading...</h3>

                return (
                    <ListGroup flush flex>
                        {data.user.undertime_weeks.map(uw => <ListGroupItem tag="a"
                                                                            href={`/timesheet?week_commencing=${moment(uw.week_commencing).format('YYYY-MM-DD')}`}>{moment(uw.week_commencing).format('DD/MM/YYYY')} ({(uw.total_minutes_worked / 60)} hrs
                            undertime)</ListGroupItem>)}
                    </ListGroup>
                )
            }}
        </Query>
    )

}